export default function EmailSvg() {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M3 7.75C3 6.51953 3.98438 5.5 5.25 5.5H18.75C19.9805 5.5 21 6.51953 21 7.75V16.75C21 18.0156 19.9805 19 18.75 19H5.25C3.98438 19 3 18.0156 3 16.75V7.75ZM4.6875 7.75V8.55859L10.7344 13.5156C11.4727 14.1133 12.4922 14.1133 13.2305 13.5156L19.3125 8.55859V7.75C19.3125 7.46875 19.0312 7.1875 18.75 7.1875H5.25C4.93359 7.1875 4.6875 7.46875 4.6875 7.75ZM4.6875 10.7383V16.75C4.6875 17.0664 4.93359 17.3125 5.25 17.3125H18.75C19.0312 17.3125 19.3125 17.0664 19.3125 16.75V10.7383L14.3203 14.8164C12.9492 15.9414 11.0156 15.9414 9.64453 14.8164L4.6875 10.7383Z'
        fill='#4B5563'
      />
    </svg>
  )
}
